<template>
  <ob-modal2 :width="800" :show.sync="openModal" :backdrop="false">
    <template slot="modal-title">
      Add Question
    </template>

    <template slot="modal-body" class="modal-pad">
      <template v-if="spinnerAddQuestion">
        <ob-spinner ></ob-spinner>
      </template>
      <template v-else>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Question*</label>
              <textarea placeholder="Enter Question" class="textarea-height" v-model="addQuestionData.QuestionTitle" v-bind:class="{ 'ob-vuelidate_input-error': $v.addQuestionData.QuestionTitle.$error }"></textarea>
              <span class="ob-vuelidate_error-msg" v-if="$v.addQuestionData.QuestionTitle.$dirty && !$v.addQuestionData.QuestionTitle.required">Please enter Question Title</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Answer*</label>
              <medium-editor :options="editorOptions" :text="addQuestionData && addQuestionData.Answer ? addQuestionData.Answer : ''" @edit='processEditOperation' custom-tag='div' :class="{ 'medium-editor-element' : true, 'ob-vuelidate_input-error': $v.addQuestionData.Answer.$error }"></medium-editor>
              <span class="ob-vuelidate_error-msg" v-if="$v.addQuestionData.Answer.$dirty && !$v.addQuestionData.Answer.required">Please enter Answer</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Question Category*</label>
              <ob-select2 :options="questionCategoryOption" :inModal="true"  v-model="addQuestionData.Category" :class="{ 'ob-vuelidate_input-error': $v.addQuestionData.Category.$error }"></ob-select2>
              <span class="ob-vuelidate_error-msg" v-if="$v.addQuestionData.Category.$dirty && !$v.addQuestionData.Category.required">Please Select Question Category</span>
            </div>
          </div>
          <div class="col-md-6" v-if="!isConsultant">
            <div class="form-group">
              <label>Question Type*</label>
              <ob-select2 :options="questionTypeOptions" v-model="addQuestionData.Type" @input="questionTypeChange" :class="{ 'ob-vuelidate_input-error': $v.addQuestionData.Type.$error }"></ob-select2>
              <span class="ob-vuelidate_error-msg" v-if="$v.addQuestionData.Type.$dirty && !$v.addQuestionData.Type.required">Please Select Question Type</span>
            </div>
          </div>
        </div>

        <div v-if="addQuestionData.Type =='EmployeeSpecific' && !isConsultant && $route.name != 'fdns-report-visit'" class="questiontypebase">
          <template v-if="spinnerEmployeerName">
            <ob-spinner></ob-spinner>
          </template>
          <template v-else>

            <!-- Employee Selection -->
            <div class="select-employees-wrapper">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <h4 style="color: #143361;">Select Employees*</h4>
                    <p class="ob-vuelidate_error-msg" v-if="$v.addQuestionData.$dirty && (!addQuestionData.employeeIds || addQuestionData.employeeIds.length == 0)">Please select alteast one employee</p>
                  </div>
                </div>
                <div class="col-md-6 text-right">
                  <div class="form-group">
                    <ob-checkbox v-model="selectAllEmployees" :val="true" @change.native="onSelectAllEmployeesChange">Select All</ob-checkbox>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4" v-for="(e, index) in changeEmployeerData" :key="index">
                  <div class="form-group">
                    <ob-checkbox v-model="selectedEmployeeIds" :val="e.ConsultantId" :key="`checkbox${index}`">{{e.ConsultantName}}<template slot="small">{{e.EmailAddress}}</template></ob-checkbox>
                  </div>
                </div>
              </div>
            </div>
            <!--// Employee Selection -->

          </template>
        </div>

        <!-- Attachment -->
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <ob-checkbox v-model="attachDocument" :val="true">Attach related document to this question</ob-checkbox>
            </div>
          </div>
        </div>
        <div class="row" v-if="attachDocument">
          <div class="col-md-12">
            <div class="form-group col-md-12">
                <label>Upload Document</label><span>*</span>
                <p style="font-style: italic; margin-bottom: 10px; font-size: 12px;">We accept either pdf, .doc, .docx, zip, images upto 100MB.</p>
                <ob-upload-new :validation="Validation" :end-point="EndPoint" @file-complete="onFileComplete" @remove-file="addQuestionData.AttachmentUrl = ''" :type="2" :IsFileExists="addQuestionData.AttachmentUrl | URL2FileName" :isUploading.sync="isUploading" ref="uploadDocument1">
                    <template slot="file-text">
                        <i class="fa fa-cloud-upload" aria-hidden="true"></i> Drag and Drop   OR   Choose File
                    </template>
                </ob-upload-new>
                <span class="ob-vuelidate_error-msg" style="padding-left: 5px"
                                v-if="isErrorMessageDisabled && $refs.uploadDocument1.Errors.length == 0" >{{errorMessageFrmResponse}} </span>
                <span class="ob-vuelidate_error-msg" v-else-if="$v.addQuestionData.AttachmentUrl.$dirty && !$v.addQuestionData.AttachmentUrl.required">Please upload the document</span>
            </div>
          </div>
        </div>
        <!--// Attachment -->

      </template>
    </template>
    <template slot="modal-footer" v-if="!spinnerAddQuestion">
      <!-- Workaround for showing tooltip when the buttons are disabled-->
      <template v-if="isUploading">
        <ob-button type="secondary" :disabled="isUploading">
          <span v-tooltip="{ content: 'Please wait for the document to upload', visible: isUploading }">Cancel</span>
        </ob-button>
        <ob-button type="primary" :disabled="isUploading">
          <span v-tooltip="{ content: 'Please wait for the document to upload', visible: isUploading }">Add</span>
        </ob-button>
      </template>
      <template v-else>
        <ob-button type="secondary" @click="openModal=false">Cancel</ob-button>
        <ob-button type="primary" @click="isAddData(addQuestionData)">Add</ob-button>
      </template>
    </template>
  </ob-modal2>
</template>
<script>
import c from '@/components/Core/constants.js'
import editor from "vue2-medium-editor";
import FDNSQuestionAns from "../FDNSQuestionAndAnswer.vue";
import {
  required,
  requiredIf,
  minLength
} from "vuelidate/lib/validators";
export default {
  props: ["openAddQuestionPopUp"],
  data() {
    return {
      // Attachments
      Validation: {
          Rules: {
              Type: ["pdf", "zip", "doc", "docx", "png", "gif", "jpg", "jpeg"],
              Size: 110000000 // In Bytes
          },
          Messages: {
              Type: "Please upload valid file formats",
              Size: `Please upload a file which is less than 100MB`
          }
      },
      EndPoint: `${c.APIBASEURL}/File/FileUpload`,
      attachDocument: false,
      isUploading: false,


      //Editor
      editorOptions: {
        placeholder: {
          text: "Enter Answer"
        },
        paste: {
          forcePlainText: false,
          cleanPastedHTML: false
        }
      },

      // Employees Selection
      selectAllEmployees: false,

      errorMessageFrmResponse:'',
      isErrorMessageDisabled: false,
      // Common
      categorySelectData: "",
      spinnerAddQuestion: false,
      spinnerEmployeerName: false,
      changeEmployeerData: "",
      dataEmployeerNameDteails: "",
      questionCategoryOption: {
        placeholder: {
          id: "-1",
          text: "Question Category"
        },
        data: []
      },
      questionTypeOptions: {
        data: [
          {
              id: "EmployerSpecific",
            text: "Employer Questions"
          },
          {
              id: "EmployeeSpecific",
            text: "Employee Specific Questions"
          }
          // {
          //   id: "FDNSVisitHistory",
          //   text: "FDNS Visit History"
          // }
        ],
        placeholder: "Question Type"
      },
      addQuestionData: {
        QuestionTitle: "",
        Answer: "",
        Category: "",
        Type: "",
        AttachmentUrl: null,
        employeeIds: []
      },
      selectedEmployeeIds: [],
      openModal: ""
    };
  },
  created() {
    this.openModal = this.openAddQuestionPopUp;
  },
  watch: {
    selectedEmployeeIds(v) {

      this.addQuestionData.employeeIds = v
      if(v.length != this.changeEmployeerData.length && this.selectAllEmployees === true) {
        this.selectAllEmployees = false
      } else if(this.changeEmployeerData.length > 0 && v.length == this.changeEmployeerData.length && this.selectAllEmployees === false) {
        this.selectAllEmployees = true
      }
    },
    openAddQuestionPopUp(val) {
      this.openModal = val;
    },
    openModal(val) {
      this.$emit("update:openAddQuestionPopUp", val);
      if (val == true) {
        this.categoryData();
      }
      if (val == false) {
        this.resetData()
      }
    }
  },
  validations() {
    return {
      addQuestionData: {
        QuestionTitle: {
          required
        },
        Answer: {
          required
        },
        Category: {
          required
        },
        Type: {
          required: requiredIf(() => {
            return !this.isConsultant
          })
        },
        // employeeIds: {
        //   required,
        //   minLength: minLength(1)
        // },
        AttachmentUrl: {
          required: requiredIf(() => {
            return this.attachDocument
          })
        }
      }
    };
  },
  components: {
    "medium-editor": editor
  },
  methods: {
    resetData() {
      this.$v.addQuestionData.$reset();
      this.addQuestionData = {
        QuestionTitle: "",
        Answer: "",
        Category: "",
        Type: "",
        AttachmentUrl: null,
        employeeIds: []
      };
      this.attachDocument = false
      this.selectAllEmployees = false
      this.selectedEmployeeIds = []
    },
    onSelectAllEmployeesChange() {
      if(this.selectAllEmployees == true) {
        this.selectedEmployeeIds = __.map(this.changeEmployeerData, e => e.ConsultantId)
      } else {
        this.selectedEmployeeIds = []
      }
    },
    onFileComplete(fileQueue) {
        if (fileQueue[0].response.Url) {
          this.addQuestionData.AttachmentUrl = fileQueue[0].response.Url
          this.isErrorMessageDisabled=false
        }
        if (fileQueue[0].response.State==false && fileQueue[0].response.Message!=null)
        {
          this.$refs.uploadDocument1.CancelUpload()
          this.isErrorMessageDisabled=true
          this.errorMessageFrmResponse=fileQueue[0].response.Message
        }
    },
    processEditOperation(operation) {
      let text = operation.api.origElements.innerHTML;
      // Hot Fix
      // Since the original repo has this open issue
      // https://codesandbox.io/s/v841qqzmy7
      if(text == "<p><br></p>") {
        this.addQuestionData.Answer = "";
      } else {
        this.addQuestionData.Answer = operation.api.origElements.innerHTML;
      }
    },
    isAddData(r) {
      if (this.isConsultant) {
          this.addQuestionData.Type = "EmployeeSpecific";
      }
      this.$v.addQuestionData.$touch();
      if (this.$v.addQuestionData.$invalid != true) {

          if(!this.isConsultant && this.$route.name != "fdns-report-visit" && this.addQuestionData.Type == "EmployeeSpecific" && (!this.addQuestionData.employeeIds || this.addQuestionData.employeeIds.length == 0)) {
          return false //TODO:: handled with work around for the array validation in vuelidate, fix with vuelidate
        }

        this.$loading({ loadingText: "Loading..." });
        let params = {
          Answer: r.Answer,
          QuestionTitle: r.QuestionTitle,
          Type: r.Type,
          IsSelectAll: false,
          IsHide: false,
          IsManual: true,
          IsQuestionAddedByEmployee: true
        };
        this.categorySelectData.forEach(w => {
          if (r.Category == w.Id) {
            params.Category = {
              Name: w.Name,
              Id: w.Id
            };
          }
        });
        if (this.addQuestionData.Type == "EmployeeSpecific") {
          if (this.isConsultant) {
            params.ConsultantIds = [this.loggedInUserObj.consultantId];
          } else {
            if (this.$route.name == "fdns-report-visit") {
              if (this.$route.query.type == "Edit") {
                params.ConsultantIds = [
                  this.$store.getters.getFDNSSelectedReportDetails.FdnsModel
                    .Employee.ConsultantId
                ];
              } else {
                params.ConsultantIds = [
                  this.$store.getters.getFDNSConsultantId
                ];
              }
            } else {
              params.ConsultantIds = r.employeeIds;
            }
          }
        } else {
          params.ConsultantIds = null;
        }
        var OrgDataId = "";
        if (this.isConsultant) {
          OrgDataId = this.$store.getters.getFDNSEmpOrgId;
        }

        // Attachment
        if(this.attachDocument) {
          params.DocumentUrl = r.AttachmentUrl
        }

        ajax.post(
          `/FDNSAudit/AddQuestion?empOrgId=${OrgDataId}`,
          params,
          res => {
            this.$loading({}).close();
            if (res.data.State == true) {
              this.openModal = false;
              this.$message({
                type: "success",
                message: "Question added Successfully"
              });
              this.$emit("questionAdded", this.addQuestionData.Type);
            } else {
              this.ESSEnableDisable(res)
              this.$message({
                type: "error",
                message: res.data.Message
              });
            }
          }
        );
      }
    },
    categoryData() {
      this.spinnerAddQuestion = true;
      let url = `/FDNSAudit/GetQuestionCategoryList?empOrgId=`
      if(this.isConsultant) {
        url += this.$store.getters.getFDNSEmpOrgId
      } else {
        url += this.loggedInUserObj.OrgId
      }

      ajax.get(url,
        {},
        res => {
          if (res.data.State == true) {
            this.categorySelectData = res.data.FdnsModel;
            this.questionCategoryOption.data = __.map(res.data.FdnsModel, t => {
              return { id: t.Id, text: t.Name };
            });
          } else {
            this.ESSEnableDisable(res)
            this.$message({
              type: "error",
              message: res.data.Message
            });
          }
          this.spinnerAddQuestion = false;
        }
      );
    },
    EmployeeDetailsData(i) {
      this.changeEmployeerData.forEach(o => {
        if (o.ConsultantId == i) {
          this.dataEmployeerNameDteails = o;
        }
      });
    },
    questionTypeChange(t) {
        if (t == "EmployeeSpecific") {
        this.spinnerEmployeerName = true;
        ajax.get(`/OnBoarding/GetEmployeeList`, {}, res => {
          if (res.data.State == true) {
            this.changeEmployeerData = res.data.resultList;
            this.spinnerEmployeerName = false;
          } else {
           // this.ESSEnableDisable(res)
            this.$message({
              type: "error",
              message: res.data.Message
            });
          }
        });
      }
    },
    getQuestionCategoryDetails(questionCategoryValues, key) {
      if (questionCategoryValues != "" && questionCategoryValues[key] != null) {
        let docData = questionCategoryValues;
        let keyData = key;
        return docData[keyData];
      }

      return "N/A";
    }
  }
};
</script>
<style scoped>
textarea {
  background: #fff;
  border: 1px solid #f1f1f1;
  border-radius: 5px;
  width: 100%;
  height: 90px;
  resize: none;
  color: #555555;
}

.modal-pad {
  padding: 35px;
}

.questiontypebase {
  margin-top: 0px;
}

.ob-margin-no {
  margin-top: 15px;
}

.name-txt {
  color: #30303f;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.textarea-height {
  height: 60px;
  padding: 6px 12px;
}

.select-employees-wrapper {
  border-top: 1px dashed #c1c1c1;
  border-bottom: 1px dashed #c1c1c1;
  padding: 15px 0;
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/FDNS/FDNS-PopUp/AddQuestions.vue